import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useRef, useCallback, useEffect } from 'react';
import { useFloating, shift, getOverflowAncestors } from '@floating-ui/react';
function useFloatingTooltip(_ref) {
  var offset = _ref.offset,
    position = _ref.position;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var boundaryRef = useRef();
  var _useFloating = useFloating({
      placement: position,
      middleware: [shift({
        crossAxis: true,
        padding: 5,
        rootBoundary: "document"
      })]
    }),
    x = _useFloating.x,
    y = _useFloating.y,
    reference = _useFloating.reference,
    floating = _useFloating.floating,
    refs = _useFloating.refs,
    update = _useFloating.update,
    placement = _useFloating.placement;
  var horizontalOffset = placement.includes("right") ? offset : position.includes("left") ? offset * -1 : 0;
  var verticalOffset = placement.includes("bottom") ? offset : position.includes("top") ? offset * -1 : 0;
  var handleMouseMove = useCallback(function (_ref2) {
    var clientX = _ref2.clientX,
      clientY = _ref2.clientY;
    reference({
      getBoundingClientRect: function getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          x: clientX,
          y: clientY,
          left: clientX + horizontalOffset,
          top: clientY + verticalOffset,
          right: clientX,
          bottom: clientY
        };
      }
    });
  }, [reference]);
  useEffect(function () {
    if (refs.floating.current) {
      var boundary = boundaryRef.current;
      boundary.addEventListener("mousemove", handleMouseMove);
      var parents = getOverflowAncestors(refs.floating.current);
      parents.forEach(function (parent) {
        parent.addEventListener("scroll", update);
      });
      return function () {
        boundary.removeEventListener("mousemove", handleMouseMove);
        parents.forEach(function (parent) {
          parent.removeEventListener("scroll", update);
        });
      };
    }
    return void 0;
  }, [reference, refs.floating, update, handleMouseMove, opened]);
  return {
    handleMouseMove: handleMouseMove,
    x: x,
    y: y,
    opened: opened,
    setOpened: setOpened,
    boundaryRef: boundaryRef,
    floating: floating
  };
}
export { useFloatingTooltip };